export default "__VITE_ASSET__BjMcBTvJ__"